import React, { useContext } from 'react'
import './Hackathon.css'

import Header from '../../Components/Header/Header'
import Intro from '../../Components/Intro/Intro'
import About from '../../Components/About/About'
import DataSet from '../../Components/DataSet/DataSet'
import Evaluation from '../../Components/Evaluation/Evaluation'
import FAQComponent from '../../Components/FAQComponent/FAQComponent'
import PrizeMoney from '../../Components/PrizeMoney/PrizeMoney'
import Submission from '../../Components/Submission/Submission'
import Footer from '../../Components/FooterComponent/Footer'
import HackathonType from '../../Components/HackathonType/HackathonType'
import { MainContext } from '../../Components/ContextStore/MainContext'
import HackathonBox from '../../Components/HackathonBox/HackathonBox'
import HackathonWinners from '../../Components/HackathonWinners/HackathonWinners'

export default function Hackathon() {
  const { hackathonType } = useContext(MainContext)

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = -90;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition + offset,
        behavior: "smooth",
      });
    }
  };


  return (
    <div style={{ width: "98.5", overflowX: "hidden" }}>
      <Header onScrollTo={scrollToSection} />
      <Intro />
      <HackathonType />

      {hackathonType === "current" && <div className='main_components'>

        <div id='about'>
          <About />
        </div>

        <div id='dataset'>
          <DataSet />
        </div>

        <div id='evaluation'>
          <Evaluation />
        </div>

        <div id='prizes'>
          <PrizeMoney />
        </div>

        <div id='submission'>
          <Submission />
        </div>

        <div id='faq'>
          <FAQComponent />
        </div>

      </div>}

      {hackathonType === "pastHackathons" && <div className='main_components'>
        <HackathonBox />
        <HackathonWinners/>
      </div>}

      <Footer />

    </div>

  )
}
